var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 85,
    viewBox: "0 0 84 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77 80.6815C77 78.9242 78.4246 77.4996 80.1818 77.4996C81.9391 77.4996 83.3636 78.9242 83.3636 80.6815C83.3636 82.4387 81.9391 83.8633 80.1818 83.8633C78.4246 83.8633 77 82.4387 77 80.6815Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77 65.408C77 63.6508 78.4246 62.2262 80.1818 62.2262C81.9391 62.2262 83.3636 63.6508 83.3636 65.408C83.3636 67.1653 81.9391 68.5898 80.1818 68.5898C78.4246 68.5898 77 67.1653 77 65.408Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77 50.1365C77 48.3793 78.4246 46.9547 80.1818 46.9547C81.9391 46.9547 83.3636 48.3793 83.3636 50.1365C83.3636 51.8938 81.9391 53.3184 80.1818 53.3184C78.4246 53.3184 77 51.8938 77 50.1365Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77 34.8631C77 33.1058 78.4246 31.6813 80.1818 31.6813C81.9391 31.6813 83.3636 33.1058 83.3636 34.8631C83.3636 36.6204 81.9391 38.0449 80.1818 38.0449C78.4246 38.0449 77 36.6204 77 34.8631Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77 19.5897C77 17.8324 78.4246 16.4078 80.1818 16.4078C81.9391 16.4078 83.3636 17.8324 83.3636 19.5897C83.3636 21.3469 81.9391 22.7715 80.1818 22.7715C78.4246 22.7715 77 21.3469 77 19.5897Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77 4.31818C77 2.56093 78.4246 1.13636 80.1818 1.13636C81.9391 1.13636 83.3636 2.56093 83.3636 4.31818C83.3636 6.07545 81.9391 7.5 80.1818 7.5C78.4246 7.5 77 6.07545 77 4.31818Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.7273 80.6815C61.7273 78.9242 63.1519 77.4996 64.9091 77.4996C66.6664 77.4996 68.0909 78.9242 68.0909 80.6815C68.0909 82.4387 66.6664 83.8633 64.9091 83.8633C63.1519 83.8633 61.7273 82.4387 61.7273 80.6815Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.7273 65.408C61.7273 63.6508 63.1519 62.2262 64.9091 62.2262C66.6664 62.2262 68.0909 63.6508 68.0909 65.408C68.0909 67.1653 66.6664 68.5898 64.9091 68.5898C63.1519 68.5898 61.7273 67.1653 61.7273 65.408Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.7273 50.1365C61.7273 48.3793 63.1519 46.9547 64.9091 46.9547C66.6664 46.9547 68.0909 48.3793 68.0909 50.1365C68.0909 51.8938 66.6664 53.3184 64.9091 53.3184C63.1519 53.3184 61.7273 51.8938 61.7273 50.1365Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.7273 34.8631C61.7273 33.1058 63.1519 31.6813 64.9091 31.6813C66.6664 31.6813 68.0909 33.1058 68.0909 34.8631C68.0909 36.6204 66.6664 38.0449 64.9091 38.0449C63.1519 38.0449 61.7273 36.6204 61.7273 34.8631Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.7273 19.5897C61.7273 17.8324 63.1519 16.4078 64.9091 16.4078C66.6664 16.4078 68.0909 17.8324 68.0909 19.5897C68.0909 21.3469 66.6664 22.7715 64.9091 22.7715C63.1519 22.7715 61.7273 21.3469 61.7273 19.5897Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.7273 4.31818C61.7273 2.56093 63.1519 1.13636 64.9091 1.13636C66.6664 1.13636 68.0909 2.56093 68.0909 4.31818C68.0909 6.07545 66.6664 7.5 64.9091 7.5C63.1519 7.5 61.7273 6.07545 61.7273 4.31818Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4545 80.6815C46.4545 78.9242 47.879 77.4996 49.6363 77.4996C51.3936 77.4996 52.8181 78.9242 52.8181 80.6815C52.8181 82.4387 51.3936 83.8633 49.6363 83.8633C47.879 83.8633 46.4545 82.4387 46.4545 80.6815Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4545 65.408C46.4545 63.6508 47.879 62.2262 49.6363 62.2262C51.3936 62.2262 52.8181 63.6508 52.8181 65.408C52.8181 67.1653 51.3936 68.5898 49.6363 68.5898C47.879 68.5898 46.4545 67.1653 46.4545 65.408Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4545 50.1365C46.4545 48.3793 47.879 46.9547 49.6363 46.9547C51.3936 46.9547 52.8181 48.3793 52.8181 50.1365C52.8181 51.8938 51.3936 53.3184 49.6363 53.3184C47.879 53.3184 46.4545 51.8938 46.4545 50.1365Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4545 34.8631C46.4545 33.1058 47.879 31.6813 49.6363 31.6813C51.3936 31.6813 52.8181 33.1058 52.8181 34.8631C52.8181 36.6204 51.3936 38.0449 49.6363 38.0449C47.879 38.0449 46.4545 36.6204 46.4545 34.8631Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip16_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4545 19.5897C46.4545 17.8324 47.879 16.4078 49.6363 16.4078C51.3936 16.4078 52.8181 17.8324 52.8181 19.5897C52.8181 21.3469 51.3936 22.7715 49.6363 22.7715C47.879 22.7715 46.4545 21.3469 46.4545 19.5897Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip17_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.4545 4.31818C46.4545 2.56093 47.879 1.13636 49.6363 1.13636C51.3936 1.13636 52.8181 2.56093 52.8181 4.31818C52.8181 6.07545 51.3936 7.5 49.6363 7.5C47.879 7.5 46.4545 6.07545 46.4545 4.31818Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip18_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1818 80.6815C31.1818 78.9242 32.6063 77.4996 34.3636 77.4996C36.1209 77.4996 37.5454 78.9242 37.5454 80.6815C37.5454 82.4387 36.1209 83.8633 34.3636 83.8633C32.6063 83.8633 31.1818 82.4387 31.1818 80.6815Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip19_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1818 65.408C31.1818 63.6508 32.6063 62.2262 34.3636 62.2262C36.1209 62.2262 37.5454 63.6508 37.5454 65.408C37.5454 67.1653 36.1209 68.5898 34.3636 68.5898C32.6063 68.5898 31.1818 67.1653 31.1818 65.408Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip20_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1818 50.1365C31.1818 48.3793 32.6063 46.9547 34.3636 46.9547C36.1209 46.9547 37.5454 48.3793 37.5454 50.1365C37.5454 51.8938 36.1209 53.3184 34.3636 53.3184C32.6063 53.3184 31.1818 51.8938 31.1818 50.1365Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip21_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1818 34.8631C31.1818 33.1058 32.6063 31.6813 34.3636 31.6813C36.1209 31.6813 37.5454 33.1058 37.5454 34.8631C37.5454 36.6204 36.1209 38.0449 34.3636 38.0449C32.6063 38.0449 31.1818 36.6204 31.1818 34.8631Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip22_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1818 19.5897C31.1818 17.8324 32.6063 16.4078 34.3636 16.4078C36.1209 16.4078 37.5454 17.8324 37.5454 19.5897C37.5454 21.3469 36.1209 22.7715 34.3636 22.7715C32.6063 22.7715 31.1818 21.3469 31.1818 19.5897Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip23_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1818 4.31818C31.1818 2.56093 32.6063 1.13636 34.3636 1.13636C36.1209 1.13636 37.5454 2.56093 37.5454 4.31818C37.5454 6.07545 36.1209 7.5 34.3636 7.5C32.6063 7.5 31.1818 6.07545 31.1818 4.31818Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip24_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9091 80.6815C15.9091 78.9242 17.3336 77.4996 19.0909 77.4996C20.8482 77.4996 22.2727 78.9242 22.2727 80.6815C22.2727 82.4387 20.8482 83.8633 19.0909 83.8633C17.3336 83.8633 15.9091 82.4387 15.9091 80.6815Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip25_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9091 65.408C15.9091 63.6508 17.3336 62.2262 19.0909 62.2262C20.8482 62.2262 22.2727 63.6508 22.2727 65.408C22.2727 67.1653 20.8482 68.5898 19.0909 68.5898C17.3336 68.5898 15.9091 67.1653 15.9091 65.408Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip26_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9091 50.1365C15.9091 48.3793 17.3336 46.9547 19.0909 46.9547C20.8482 46.9547 22.2727 48.3793 22.2727 50.1365C22.2727 51.8938 20.8482 53.3184 19.0909 53.3184C17.3336 53.3184 15.9091 51.8938 15.9091 50.1365Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip27_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9091 34.8631C15.9091 33.1058 17.3336 31.6813 19.0909 31.6813C20.8482 31.6813 22.2727 33.1058 22.2727 34.8631C22.2727 36.6204 20.8482 38.0449 19.0909 38.0449C17.3336 38.0449 15.9091 36.6204 15.9091 34.8631Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip28_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9091 19.5897C15.9091 17.8324 17.3336 16.4078 19.0909 16.4078C20.8482 16.4078 22.2727 17.8324 22.2727 19.5897C22.2727 21.3469 20.8482 22.7715 19.0909 22.7715C17.3336 22.7715 15.9091 21.3469 15.9091 19.5897Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip29_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9091 4.31818C15.9091 2.56093 17.3336 1.13636 19.0909 1.13636C20.8482 1.13636 22.2727 2.56093 22.2727 4.31818C22.2727 6.07545 20.8482 7.5 19.0909 7.5C17.3336 7.5 15.9091 6.07545 15.9091 4.31818Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip30_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.636363 80.6815C0.636363 78.9242 2.06093 77.4996 3.81818 77.4996C5.57545 77.4996 7 78.9242 7 80.6815C7 82.4387 5.57545 83.8633 3.81818 83.8633C2.06093 83.8633 0.636363 82.4387 0.636363 80.6815Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip31_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.636363 65.408C0.636363 63.6508 2.06093 62.2262 3.81818 62.2262C5.57545 62.2262 7 63.6508 7 65.408C7 67.1653 5.57545 68.5898 3.81818 68.5898C2.06093 68.5898 0.636363 67.1653 0.636363 65.408Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip32_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.636363 50.1365C0.636363 48.3793 2.06093 46.9547 3.81818 46.9547C5.57545 46.9547 7 48.3793 7 50.1365C7 51.8938 5.57545 53.3184 3.81818 53.3184C2.06093 53.3184 0.636363 51.8938 0.636363 50.1365Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip33_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.636363 34.8631C0.636363 33.1058 2.06093 31.6813 3.81818 31.6813C5.57545 31.6813 7 33.1058 7 34.8631C7 36.6204 5.57545 38.0449 3.81818 38.0449C2.06093 38.0449 0.636363 36.6204 0.636363 34.8631Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip34_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.636363 19.5897C0.636363 17.8324 2.06093 16.4078 3.81818 16.4078C5.57545 16.4078 7 17.8324 7 19.5897C7 21.3469 5.57545 22.7715 3.81818 22.7715C2.06093 22.7715 0.636363 21.3469 0.636363 19.5897Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip35_2179_17039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.636363 4.31818C0.636363 2.56093 2.06093 1.13636 3.81818 1.13636C5.57545 1.13636 7 2.56093 7 4.31818C7 6.07545 5.57545 7.5 3.81818 7.5C2.06093 7.5 0.636363 6.07545 0.636363 4.31818Z",
    stroke: "#062B96",
    strokeWidth: 0.715909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 84 84.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 84 69.2266)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 84 53.9551)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 84 38.6816)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 84 23.4082)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 84 8.13672)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 68.7273 84.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 68.7273 69.2266)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 68.7273 53.9551)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 68.7273 38.6816)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 68.7273 23.4082)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 68.7273 8.13672)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 53.4546 84.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 53.4546 69.2266)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 53.4546 53.9551)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 53.4546 38.6816)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 53.4546 23.4082)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 53.4546 8.13672)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 38.1818 84.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 38.1818 69.2266)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 38.1818 53.9551)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 38.1818 38.6816)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip22_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 38.1818 23.4082)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip23_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 38.1818 8.13672)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip24_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 22.9091 84.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip25_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 22.9091 69.2266)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip26_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 22.9091 53.9551)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip27_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 22.9091 38.6816)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip28_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 22.9091 23.4082)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip29_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 22.9091 8.13672)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip30_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 7.63635 84.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip31_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 7.63635 69.2266)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip32_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 7.63635 53.9551)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip33_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 7.63635 38.6816)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip34_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 7.63635 23.4082)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip35_2179_17039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.63636,
    height: 7.63636,
    fill: "white",
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 7.63635 8.13672)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/Dots.2d0bfbb242e677056a2785f5dc24a4be.svg";
export { ForwardRef as ReactComponent };